import { BaseEntity, LanguageDictionary } from '@starsoft/common/models';
import { GameType } from '../gameType';

export class GameDifficulty extends BaseEntity {
  name: LanguageDictionary;
  description: LanguageDictionary;
  gameType: GameType;
  gameTypeId: bigint;
}
